import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { ScrollView, View } from 'react-native';
import styled from 'styled-components/native';
import GotoIcon from '@/assets/icon/ic_goto.svg';
import { ScreenLayout } from '@/components/ScreenLayout';
import { SccTouchableOpacity } from '@/components/SccTouchableOpacity';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import { MOBILITY_TOOL_LABELS } from '@/constant/mobilityTool';
import { useMe } from '@/atoms/Auth';
import { useInterestedRegionGroupLabelMap } from '@/hooks/useListInterestedRegions';
import useNavigation from '@/navigation/useNavigation';
import { THEME_LABEL_BY_VALUE } from '@/screens/InterestedRegionAndThemesFormScreen';
export default function ProfileEditorScreen() {
    var _a, _b;
    const { userInfo } = useMe();
    const interestedRegionIds = (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.interestedRegionIds) !== null && _a !== void 0 ? _a : [];
    const interestedThemes = (_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.interestedThemes) !== null && _b !== void 0 ? _b : [];
    const regionLabelMap = useInterestedRegionGroupLabelMap();
    const navigation = useNavigation();
    const regionSummary = interestedRegionIds.length === 0
        ? null
        : interestedRegionIds.map(id => { var _a; return (_a = regionLabelMap[id]) !== null && _a !== void 0 ? _a : id; }).join(', ');
    const themeSummary = interestedThemes.length === 0
        ? null
        : interestedThemes.map(theme => THEME_LABEL_BY_VALUE[theme]).join(', ');
    return (_jsx(ScreenLayout, { isHeaderVisible: true, children: _jsx(ScrollView, { style: { backgroundColor: color.white }, children: _jsxs(View, { style: { alignItems: 'stretch' }, children: [_jsxs(FieldArea, { elementName: "profile_editor_nickname_field", onPress: () => navigation.navigate('ProfileEditor/Detail', {
                            field: 'nickname',
                        }), children: [_jsx(FieldLabel, { children: "\uB2C9\uB124\uC784" }), _jsxs(FieldValueWrapper, { children: [_jsx(FieldValue, { children: userInfo === null || userInfo === void 0 ? void 0 : userInfo.nickname }), _jsx(GotoIcon, {})] })] }), _jsxs(FieldArea, { elementName: "profile_editor_email_field", onPress: () => navigation.navigate('ProfileEditor/Detail', {
                            field: 'email',
                        }), children: [_jsx(FieldLabel, { children: "\uC774\uBA54\uC77C" }), _jsxs(FieldValueWrapper, { children: [_jsx(FieldValue, { children: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email }), _jsx(GotoIcon, {})] })] }), _jsxs(FieldArea, { elementName: "profile_editor_birth_year_field", onPress: () => navigation.navigate('ProfileEditor/Detail', {
                            field: 'birthYear',
                        }), children: [_jsx(FieldLabel, { children: "\uD0DC\uC5B4\uB09C \uD574" }), _jsxs(FieldValueWrapper, { children: [_jsx(FieldValue, { children: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.birthYear)
                                            ? `${userInfo === null || userInfo === void 0 ? void 0 : userInfo.birthYear.toString()}년`
                                            : '' }), _jsx(GotoIcon, {})] })] }), _jsxs(FieldArea, { elementName: "profile_editor_mobility_tools_field", onPress: () => navigation.navigate('ProfileEditor/Detail', {
                            field: 'mobilityTools',
                        }), children: [_jsx(FieldLabel, { children: "\uB098\uC758 \uC774\uB3D9\uC720\uD615" }), _jsxs(FieldValueWrapper, { children: [_jsx(FieldValue, { numberOfLines: 1, children: userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobilityTools.map(tool => MOBILITY_TOOL_LABELS[tool]).join(', ') }), _jsx(GotoIcon, {})] })] }), _jsxs(FieldArea, { elementName: "profile_editor_interested_region_field", onPress: () => navigation.navigate('EditInterestedRegion', {}), children: [_jsx(FieldLabel, { children: "\uAD00\uC2EC \uC9C0\uC5ED" }), _jsxs(FieldValueWrapper, { children: [regionSummary !== null ? (_jsx(FieldValue, { numberOfLines: 1, children: regionSummary })) : (_jsx(FieldPlaceholder, { numberOfLines: 1, children: "\uAD00\uC2EC \uC788\uB294 \uC9C0\uC5ED\uC744 \uC54C\uB824\uC8FC\uC138\uC694" })), _jsx(GotoIcon, {})] })] }), _jsxs(FieldArea, { elementName: "profile_editor_interested_theme_field", onPress: () => navigation.navigate('EditInterestedThemes', {}), children: [_jsx(FieldLabel, { children: "\uAD00\uC2EC \uC8FC\uC81C" }), _jsxs(FieldValueWrapper, { children: [themeSummary !== null ? (_jsx(FieldValue, { numberOfLines: 1, children: themeSummary })) : (_jsx(FieldPlaceholder, { numberOfLines: 1, children: "\uAD00\uC2EC \uC788\uB294 \uC8FC\uC81C\uB97C \uC54C\uB824\uC8FC\uC138\uC694" })), _jsx(GotoIcon, {})] })] })] }) }) }));
}
const FieldArea = styled(SccTouchableOpacity) `
  padding: 20px;
  gap: 8px;
  flex-direction: column;
  align-items: stretch;
`;
const FieldLabel = styled.Text `
  font-size: 14px;
  font-family: ${font.pretendardMedium};
  color: ${color.gray50};
`;
const FieldValueWrapper = styled.View `
  flex-direction: row;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
`;
const FieldValue = styled.Text `
  flex-shrink: 1;
  font-size: 16px;
  font-family: ${font.pretendardMedium};
  color: ${color.black};
`;
/**
 * 관심 지역/주제가 선택되지 않은 상태의 placeholder 텍스트.
 * Figma 1648:40972 기준으로 brand 색(#0E64D3)으로 노출.
 */
const FieldPlaceholder = styled.Text `
  flex-shrink: 1;
  font-size: 16px;
  font-family: ${font.pretendardMedium};
  color: ${color.brand50};
`;
